export const getItem = (key)=>{
    return  localStorage.getItem(key);
}

export const setItem = (key,value) =>{
    return localStorage.setItem(key, value);

}

export const clearItem = ()=>{
    return  localStorage.clear();
}

export const removeSetItem = (key)=>{
    return  localStorage.removeItem(key);
}